import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "20",
  height: "11",
  viewBox: "0 0 20 11",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      id: "vector",
      d: "M1.45825 9.40278L4.57007 5.86087C5.20015 5.14371 6.3027 5.10129 6.98602 5.76794L10.3762 9.07546C11.0869 9.76885 12.2425 9.69089 12.8537 8.90832L18.5416 1.625",
      stroke: "currentColor",
      "stroke-width": "1.5",
      "stroke-linecap": "round",
      "stroke-linejoin": "round"
    }, null, -1)
  ])))
}
export default { render: render }